import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getUserLoginHistory } from "../services/adminService";
import toast from "react-hot-toast";
import { fetchProfile } from "../services/api/profileService";

export default function LoginHistory() {
  const { id } = useParams();
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState(null);

  const fetchUserProfile = async () => {
    try {
      const res = await fetchProfile();
      setProfile(res || null);
    } catch (err) {
      console.error("Profile fetch failed");
    }
  };

  useEffect(() => {
    const fetchHistory = async () => {
      if (!id) return;
      try {
        setLoading(true);
        const res = await getUserLoginHistory(id);
        // Mapping exactly to your Postman response: res.data.status and res.data.data
        if (res.data?.status) {
          setHistory(res.data.data || []);
        }
      } catch (err) {
        toast.error("Failed to load detailed login history");
      } finally {
        setLoading(false);
      }
    };
    fetchUserProfile();
    fetchHistory();
  }, [id]);

  if (loading)
    return (
      <div className="p-10 text-center text-gray-500">
        Fetching audit logs...
      </div>
    );

  return (
    <div className="p-4 sm:p-6 bg-white rounded-xl shadow-sm m-2 sm:m-4 border border-gray-100">
      <div className="mb-6">
        <h2 className="text-xl font-bold text-gray-800">
          Login Activity Detail
        </h2>
        <p className="text-sm text-gray-500">
          User ID: <span className="font-mono text-blue-600">{id}</span>
        </p>
        <p className="text-sm text-gray-500">
          User Name: <span className="font-medium text-gray-700 ">
            {profile ? profile.name : "Loading..."}
          </span>
        </p>
      </div>

      <div className="overflow-x-auto rounded-lg border border-gray-100">
        <table className="w-full text-left text-sm">
          <thead className="bg-gray-50 text-gray-600 font-bold uppercase text-[10px] tracking-wider">
            <tr>
              <th className="px-4 py-3 border-b">SlNo</th>
              <th className="px-4 py-3 border-b">Log ID</th>
              <th className="px-4 py-3 border-b">IP Address</th>
              <th className="px-4 py-3 border-b">
                Device / Browser (User Agent)
              </th>
              <th className="px-4 py-3 border-b">Login Time</th>
              <th className="px-4 py-3 border-b">Logout Time</th>
              <th className="px-4 py-3 border-b">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50">
            {history.length > 0 ? (
              history.map((log, index) => (
                <tr
                  key={log.id}
                  className="hover:bg-gray-50/80 transition-colors"
                >
                  <td className="px-4 py-3 text-gray-500">{index + 1}</td>
                  <td className="px-4 py-3 text-gray-400 font-mono">
                    #{log.id}
                  </td>
                  <td className="px-4 py-3 font-medium text-blue-600">
                    {log.ip_address}
                  </td>
                  <td
                    className="px-4 py-3 text-gray-500 max-w-xs truncate"
                    title={log.user_agent}
                  >
                    {log.user_agent}
                  </td>
                  <td className="px-4 py-3 text-gray-700 whitespace-nowrap">
                    {log.login_at}
                  </td>
                  <td className="px-4 py-3 text-gray-500 whitespace-nowrap">
                    {log.logout_at && log.logout_at !== "0000-00-00 00:00:00"
                      ? log.logout_at
                      : "—"}
                  </td>
                  <td className="px-4 py-3">
                    {log.logout_at && log.logout_at !== "0000-00-00 00:00:00" ? (
                      <span className="text-[10px] bg-gray-100 text-gray-600 px-2 py-1 rounded font-bold">
                        CLOSED
                      </span>
                    ) : (
                      <span className="text-[10px] bg-emerald-100 text-emerald-700 px-2 py-1 rounded font-bold">
                        ACTIVE NOW
                      </span>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="6"
                  className="px-4 py-12 text-center text-gray-400 italic"
                >
                  No login logs found in the database for this user.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
